import { FETCH_STARTED, FETCH_DONE, SUBMIT_DONE, FETCH_FAILED, SUBMIT_FAILED } from '../actions/actionTypes'

const initialState = {
  userId: 0,
  alertPreferences: [],
  subscribedAlerts: undefined,
  fetching: false,
  error: ''
}

export const userPreferences = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_STARTED: {
      return {
        ...state,
        error: '',
        fetching: true
      }
    }
    case FETCH_DONE: {
      return {
        ...state,
        userId: action.payload.data.userId,
        subscribedAlerts: action.payload.data.subscribedAlerts,
        alertPreferences: action.payload.data.alertPreferences,
        error: '',
        fetching: false
      }
    }
    case SUBMIT_DONE: {
      return {
        ...state,
        error: '',
        alertPreferences: action.payload.alertPreferences,
        fetching: false
      }
    }
    case FETCH_FAILED: {
      return {
        ...state,
        error: action.payload.error,
        fetching: false
      }
    }
    case SUBMIT_FAILED: {
      return {
        ...state,
        error: action.payload.error,
        fetching: false
      }
    }
    default:
      return state
  }
}
